import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMenuPageLayoutStore = defineStore('menuPageLayout', () => {
  const isStandalone = ref(false)

  function setStandalone(value: boolean) {
    isStandalone.value = value
  }

  function reset() {
    isStandalone.value = false
  }

  return { isStandalone, setStandalone, reset }
})
